import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
// import { motion } from 'framer-motion';
import { Menu, X } from 'lucide-react';
import './Header.css';

const Header = () => {
  const { t, i18n } = useTranslation();
  const location = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const navItems = [
    { key: 'home', path: '/' },
    { key: 'about', path: '/about' },
    { key: 'menu', path: '/menu' },
    { key: 'gallery', path: '/gallery' },
    { key: 'findUs', path: '/find-us' }
  ];

  const languages = [
    { code: 'fr', name: 'Français' },
    { code: 'en', name: 'English' },
    { code: 'zh', name: '中文' }
  ];

  const changeLanguage = (langCode) => {
    i18n.changeLanguage(langCode);
  };

  const toggleMenu = () => {
    console.log('Toggle menu clicked, current state:', isMenuOpen);
    setIsMenuOpen(!isMenuOpen);
  };

  // const currentLang = languages.find(lang => lang.code === i18n.language) || languages[0];

  return (
    <header className="header">
      <div className="header-container">
        <Link to="/" className="logo">
          <img src="/images/Logo_Pacific1.png" alt="Pacific 91" className="logo-image" />
        </Link>

        {/* Desktop Navigation */}
        <nav className="nav">
          {navItems.map((item) => (
            <Link 
              key={item.key}
              to={item.path}
              className={`nav-link ${location.pathname === item.path ? 'active' : ''}`}
            >
              {t(`navigation.${item.key}`)}
            </Link>
          ))}
        </nav>

        {/* Language Switcher */}
        <div className="language-switcher">
          {languages.map((lang) => (
            <button
              key={lang.code}
              onClick={() => changeLanguage(lang.code)}
              className={`language-button ${i18n.language === lang.code ? 'active' : ''}`}
            >
              <span className="lang-code">{lang.code.toUpperCase()}</span>
            </button>
          ))}
        </div>

        {/* Mobile Menu Toggle */}
        <button 
          className="mobile-menu-toggle" 
          onClick={toggleMenu}
          aria-label="Toggle mobile menu"
          aria-expanded={isMenuOpen}
        >
          {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {/* Mobile Navigation */}
      <nav className={`mobile-nav ${isMenuOpen ? 'open' : ''}`}>
        {navItems.map((item) => (
          <Link 
            key={item.key}
            to={item.path}
            className={`nav-link ${location.pathname === item.path ? 'active' : ''}`}
            onClick={() => setIsMenuOpen(false)}
          >
            {t(`navigation.${item.key}`)}
          </Link>
        ))}
        
        <div className="language-switcher">
          {languages.map((lang) => (
            <button
              key={lang.code}
              onClick={() => changeLanguage(lang.code)}
              className={`language-button ${i18n.language === lang.code ? 'active' : ''}`}
            >
              <span className="lang-code">{lang.code.toUpperCase()}</span>
            </button>
          ))}
        </div>
      </nav>
    </header>
  );
};

export default Header; 